import { render, staticRenderFns } from "./set_ticket_status.vue?vue&type=template&id=0b7f751f"
import script from "./set_ticket_status.vue?vue&type=script&lang=js"
export * from "./set_ticket_status.vue?vue&type=script&lang=js"
import style0 from "./set_ticket_status.vue?vue&type=style&index=0&id=0b7f751f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports